import { axiosWeb, patchCache, version } from '../globals';

export namespace materials {
  export const getAll = async () => {
    const res = await axiosWeb.get(`/db/data.materials.min.json?${version}`);

    if (res && res.data) {
      patchCache({ materials: res.data });
    }

    return res;
  };
}
